import React from 'react';
import DisableButton from './DisableButton';
import ButtonComponent from '../components/ButtonComponent';
import { routePath } from '../routes/routePath';
import { useAuth } from '../auth/AuthContext';
function EvaluationNavigation() {
  const {userInfo} = useAuth();
  const hierarchyRole = userInfo?.hierarchyRole;
  
  const isSuperior = hierarchyRole?.includes("superior");
  const isSubordinate = hierarchyRole?.includes("subordinate");

  return (
    <div className="d-flex">
      <div className="m-auto">
        {/* Visible to all authenticated users */}
        <div className='d-inline mx-3'>
          <ButtonComponent
            className="white-color"
            text="نتائج التقييم السنوي"
            to={routePath.annualEvaluation}
          />
        </div>

        {/* If subordinate show */}
        {isSubordinate && (
        <div className='d-inline mx-3'> <ButtonComponent
        className="white-color"
        text="تقييمي   "
        to={routePath.myEvaluation}
      /></div>
        )}


        {/* If superior show */}
        {isSuperior && (
         <div className='d-inline mx-3'>
           <ButtonComponent
            className="white-color"
            text="تقييم المرؤوسين"
            to={routePath.subordinateEvaluation}
          />
         </div>
        )}


        {/* If superior show */}
        {isSuperior && (
           <div className='d-inline mx-3'>
          <ButtonComponent
            className="white-color"
            text="ارشيف التقييم"
            to={routePath.archiveEvaluations}
          />
          </div>
        )}
      </div>
    </div>
  );
} 
export default EvaluationNavigation;